var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bancos"},[_c('img',{attrs:{"src":_vm.imagen,"alt":_vm.titulo}})])}
var staticRenderFns = []

export { render, staticRenderFns }